<script>
import baseEdit from "@/views/components/base/baseEdit.vue";

let customerId = window.localStorage.getItem("customerId")
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "workType",
      key: "id",
      isParent: "1",
      url: {
        get: "/admin/system/workType",
        add: "/admin/system/workType/add",
        edit: "/admin/system/workType/edit",
      },
      items: [
        { label: "工单类型", desc: "工单类型的基本信息", type: "header" },
       /*  {
          label: "是否存在父级",
          name: "isParent",
          type: "select",
          width: "400px",
          value: "1",
          dropList: [
            {
              value: "1",
              name: "否",
            },
            {
              value: "0",
              name: "是",
            },
          ],
          onChange: this.onisParent,
        },
        {
          label: "父级工单",
          name: "parentId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
        }, */
        {
          label: "类型名称",
          name: "name",
          value: "",
          type: "input",
          width: "400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "负责人",
          name: "mainUserIds",
          value: "",
          type: "select",
          dropList: [],
          multiple: "multiple",
          width: "400px",
        },
        {
          label: "流程设置",
          name: "surgicalTransport",
          type: "select",
          width: "400px",
          value: 2,
          dropList: [
            {
              value: 1,
              name: "手术转运",
            },
            {
              value: 2,
              name: "综合服务",
            },
          ],
          onChange: this.onChangeTransport,
        },
        {
          label: "科室配置",
          name: "deskId",
          value: "",
          type: "multiple",
          dropList: [],
          width: "400px",
          onChange: this.onCouponAlis,
        },
        {
          label: "手术间配置",
          name: "operationRoom",
          value: "",
          type: "multiple",
          dropList: [],
          width: "400px",
          onChange: this.onOperationRooms,
        },
        {
          label: "资产类型",
          name: "typeId",
          value: "",
          type: "select",
          dropList: [],
          multiple: "multiple",
          width: "400px",
          desc: '如果是设备类的"工单",必须绑定资产类型',
        },
        // {
        //   label: "品牌",
        //   name: "brand",
        //   value: "",
        //   type: "input",
        //   width: "400px",
        // },
        // {
        //   label: "厂家",
        //   name: "manufacturer",
        //   value: "",
        //   type: "input",
        //   width: "400px",
        // },
        {
          label: Number(customerId) == 0 ? '客户' : '供应商',
          name: "serviceId",
          value: "",
          type: "select",
          width: "400px",
          dropList: [],
        },
        // {
        //   label: "评分",
        //   name: "score",
        //   value: 100,
        //   type: "number",
        //   min:0,
        //   max:100
        // },
        {
          label: "备注",
          name: "remark",
          value: "",
          type: "textarea",
          width: "400px",
        },
      ],
      forms: {
        createBy: $utils.data.get("auth", "userName"),
        deskIds: "",
        operationRoomsS: "",
      },
    };
  },
  async created() {
    let query = this.$route.query;
    if (query.action == "add") {
      await this.onChangeTransport(2);
      // this.items[this.getItemIndex("parentId")].type = "kong";
      // this.items[this.getItemIndex("isParent")].type = "kong";
      this.items[this.getItemIndex("typeId")].type = "select";
    }
    if (query.action == "edit") {
      // this.items[this.getItemIndex("isParent")].disabled = true;
      // this.items[this.getItemIndex("parentId")].disabled = true;
    }
    await this.loadLevelData();
    await this.deskServiceList();
    await this.loadFacilityData(query.kv);
    await this.loadInsListAll()
    await this.deskListMethod();

  },
  mounted() { },
  methods: {
    async deskListMethod() {
      let res = await $utils.api.load("/admin/system/desk/selectList");
      if (res && res.rows) {
        let ll = res.rows;

        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          let workInfotemp = "";
          if (element.deskName !== null && element.deskName !== undefined) {
            workInfotemp = element.deskName;
          }
          if (element.principal !== null && element.principal !== undefined) {
            workInfotemp = workInfotemp + "/" + element.principal;
          }
          if (element.phone !== null && element.phone !== undefined) {
            workInfotemp = workInfotemp + "/" + element.phone;
          }
          if (element.address !== null && element.address !== "") {
            workInfotemp = workInfotemp + "/" + element.address;
          }
          xx.name = workInfotemp;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "deskId") {
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "operationRoom") {
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
    async deskServiceList() {
      let res = await $utils.api.load("/admin/system/supplier/list", {}, "get");
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.supplierName;
          xx.children = element.children || [];
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "serviceId") {
            this.items[index]["dropList"] = (this.items[index]["dropList"] || []).concat(
              dropList
            );
          }
        }
      }
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.forms.deskIds = ass;
    },
    onOperationRooms(val) {
      let ass = val.join(",");
      this.forms.operationRooms = ass;
    },
    //父级工单
    loadLevelData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      $utils.api.load("/admin/system/workType/fClass", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "parentId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //资产类型
    loadInsListAll() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/selectMaiUser", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.userId;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "mainUserIds") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //资产类型
    loadFacilityData(kv) {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/facilityType/list", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            if (
              element.workTypeId == 0 ||
              element.workTypeId == null ||
              element.workTypeId == kv
            ) {
              let xx = {};
              xx.value = element.id;
              xx.name = element.facilityName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "typeId") {
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    //1代表存在父级
    //0代表不存在父级
    onisParent(val) {
      if (val == "1") {
        // this.items[this.getItemIndex("isParent")].type = "kong";
        // this.items[this.getItemIndex("parentId")].type = "kong";
        this.items[this.getItemIndex("typeId")].type = "select";
      }
      if (val == "0") {
        // this.items[this.getItemIndex("isParent")].type = "kong";
        // this.items[this.getItemIndex("parentId")].type = "select";
        this.items[this.getItemIndex("typeId")].type = "kong";
      }
    },
    onChangeTransport(val) {
      if (val == 1) {
        this.items[this.getItemIndex("deskId")].type = "multiple";
        this.items[this.getItemIndex("operationRoom")].type = "multiple";
      }
      if (val == 2) {
        this.items[this.getItemIndex("deskId")].type = "kong";
        this.items[this.getItemIndex("operationRoom")].type = "kong";
      }
    },
    initData() {
      // 加载详情数据
      let id = this.kv;
      $utils.api.load(`/admin/system/workType/${id}`, {}).then((res) => {
        if (res && res.data) {
          if (res.data.surgicalTransport == 0 || res.data.surgicalTransport == null) {
            this.surgicalTransport = 2;
            this.onChangeTransport(2);
          } else {
            this.surgicalTransport = res.data.surgicalTransport;
            this.onChangeTransport(res.data.surgicalTransport);
          }

          this.forms = res.data;
          let deskId = res.data.deskIds.split(",");
          this.forms.deskId = deskId.map(Number);
          let operationRoom = res.data.operationRooms ? res.data.operationRooms.split(",") : [];
          this.forms.operationRoom = operationRoom.map(Number);
          if (this.forms.isParent === "1") {
            this.isParent = "1";
            // this.items[this.getItemIndex("isParent")].type = "kong";
            // this.items[this.getItemIndex("parentId")].type = "kong";
            this.items[this.getItemIndex("typeId")].type = "select";
          }
          if (this.forms.isParent === "0") {
            this.isParent = "0";
            // this.items[this.getItemIndex("isParent")].type = "kong";
            // this.items[this.getItemIndex("parentId")].type = "select";
            this.items[this.getItemIndex("typeId")].type = "kong";
          }
        }
      });
    },
  },
};
</script>
